var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"title":"图片预览","width":"880px"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"img_box"},[_c('img',{attrs:{"src":_vm.src,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }